import { call, put, takeLatest } from "redux-saga/effects";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// Initial state
const initialState = {
  ip: null,
  error: false,
  loading: false,
  loaded: false,
};

// Slice
const peerIpSlice = createSlice({
  name: "peerIp",
  initialState,
  reducers: {
    getPeerIp(state) {
      return { ...state, loading: true, error: false, loaded: false };
    },
    fetchDataSuccess(state, action) {
      return {
        ...state,
        loading: false,
        ip: action.payload,
        error: false,
        loaded: true,
      };
    },
    fetchDataFailure(state, action) {
      return {
        ...state,
        loading: false,
        error: action.payload,
        loaded: true,
      };
    },
  },
});

export const { getPeerIp, fetchDataSuccess, fetchDataFailure } =
  peerIpSlice.actions;

export default peerIpSlice.reducer;

//saga
function* fetchDataSaga(action) {
  try {
    const { headers = {}, apiUrl } = action.payload;
    const apiService = axios.create({
      headers: headers,
    });
    const response = yield call(apiService.get, apiUrl);
    const { data: { x_forwarded_for } } = response.data;
    yield put(fetchDataSuccess(x_forwarded_for));
  } catch (error) {}
}

// API 호출을 감시하는 Saga 함수
export function* peerIpSaga() {
  yield takeLatest(getPeerIp.type, fetchDataSaga);
}
